import {
  Box,
  Button,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import emailVerification from "assets/images/emailVerification.svg";
import { useEffect, useState } from "react";
import history from "utils/history";
import CustomAuthCardLayout from "global/components/CustomAuthCardLayout/CustomAuthCardLayout";
import { isTruthy } from "helpers/methods";
import { resendAccountVerificationEmail } from "../OnboardingFunctions";
import CustomLoader from "global/components/CustomLoader/CustomLoader";
import urls from "global/constants/UrlConstants";
import { useTitle } from "utils/UseTitle";
import title from "global/constants/TitleConstants";

const CheckYourMail = (props: { location: any }) => {
  useTitle(title.CHECK_YOUR_EMAIL);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const email = props.location?.state?.email;
  const isFromLoginScreen = props.location?.state?.isFromLoginScreen;
  const isFromRegistrationScreen =
    props.location?.state?.isFromRegistrationScreen;
  const [isLoading, setIsLoading] = useState<boolean>();

  useEffect(() => {
    if (!isTruthy(email)) {
      history.push(urls.landingViewPath);
    }
  }, [email]);

  return (
    <>
      <CustomAuthCardLayout IsCustomAuthCardLayout={true}>
        <Box px={isMobile ? 0 : 10}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              pb: "30px",
            }}
          >
            <img
              src={emailVerification}
              width={isMobile ? "100%" : "auto"}
              alt=""
            />
          </Box>
          <Typography
            component="h1"
            variant="h5"
            color={theme.palette.neutral[700]}
            fontWeight={600}
            gutterBottom
            sx={{
              textAlign: "center",
              mb: 2,
            }}
          >
            {isFromLoginScreen || isFromRegistrationScreen
              ? "Email Verification Required"
              : "Check Your email !"}
          </Typography>
          <Typography
            variant="body1"
            color={theme.palette.neutral[700]}
            gutterBottom
            sx={{
              textAlign: "center",
              mb: 2,
              lineHeight: 1.6,
              maxWidth:
                isFromLoginScreen || isFromRegistrationScreen
                  ? "450px"
                  : "270px",
            }}
          >
            {isFromLoginScreen || isFromRegistrationScreen
              ? "It looks like your email address has not been verified yet. To access your account, please verify your email by clicking the button below. An activation link will be sent to your inbox."
              : `We've sent an email to ${
                  email ?? "you"
                } with a link to activate your account.`}
          </Typography>
          <Typography>
            <Link
              component="button"
              onClick={() => {
                resendAccountVerificationEmail(setIsLoading, email);
              }}
              sx={{
                cursor: "pointer !important",
                pl: 0.5,
                textDecoration: "underline",
                outline: "none",
                "&:focus": {
                  outline: `2px solid ${theme.palette.primary.main}`,
                },
                color: "primary.main",
                fontWeight: 500,
              }}
            >
              Send Activation Link
            </Link>
          </Typography>
        </Box>
      </CustomAuthCardLayout>
      <CustomLoader isLoading={isLoading} />
    </>
  );
};

export default CheckYourMail;
